module.exports = __webpack_public_path__ + "img/in-progress-icon.2da4d8e2.svg";